import script from "./QuestionDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionDisplay.vue?vue&type=script&setup=true&lang=js"

import "./QuestionDisplay.vue?vue&type=style&index=0&id=439d8d5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-439d8d5e"]])

export default __exports__